import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMicComponent } from "./med-icon-mic.component";

@NgModule({
  declarations: [
    MedIconMicComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMicComponent,
  ],
})
export class MedIconMicModule { }
